module.exports = __webpack_public_path__ + "static/media/controls.bfd168c4.svg";